import React, { Component } from 'react';
import { css } from 'aphrodite';
import { Flexbox } from './Styles';

import Spinner from './Spinner';
import ActionMenu from './ActionMenu';
import EventInfo from './EventInfo';

class Turn extends Component {
  constructor(props) {
    super(props);
    this.state = { turntype: null };
  }

  componentDidUpdate(prevProps) {
    if (this.props.turn !== prevProps.turn) {
      // Reset to the start of the turn every time we increment turn
      this.setState({ turntype: null });
    }
  }

  renderContent() {
    if (this.state.turntype == null) {
      return <Spinner turn={this.props.turn} onSpinStart={this.props.onSpinStart} onSpinDone={this.handleSpinDone.bind(this)} />
    } else if (this.state.turntype === 'action') {
      return <ActionMenu score={this.props.score} heldActions={this.props.heldActions} scenario={this.props.scenario} onSelect={this.onAction.bind(this)} />
    } else if (this.state.turntype === 'event') {
      let event = this.props.scenario.randomEvent()
      return <EventInfo event={event} onComplete={this.onEvent.bind(this)} />
    } else if (this.state.turntype === 'wildcard') {
      let wildcard = this.props.scenario.randomWildcard()
      return <EventInfo event={wildcard} onComplete={this.onWildcard.bind(this)} />
    }
  }

  render() {
    return(
      <div className={css(Flexbox.grow)}>
        { this.renderContent() }
      </div>
    );
  }

  handleSpinDone(turntype) {
    this.setState({turntype: turntype})
  }

  onAction(action) {
    if (action == null) {
      this.props.onTurn('nothing');
    } else {
      this.props.onTurn('action', action);
    }
  }

  onEvent(event) {
    this.props.onTurn('event', event);
  }

  onWildcard(wildcard) {
    this.props.onTurn('wildcard', wildcard);
  }
}

export default Turn;



// WEBPACK FOOTER //
// ./src/Turn.js